import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { TableRow } from '@material-ui/core'

const ZariTableRow = ({ className, ...props }) => {
  return <TableRow className={clsx('zr-tr', className)} {...props} />
}

ZariTableRow.propTypes = {
  hover: PropTypes.bool
}

export default ZariTableRow
